export const GET_UFO_OBSERVATIONS_REQUESTED = "GET_UFO_OBSERVATIONS_REQUESTED";
export const GET_UFO_OBSERVATIONS_SUCCESS = "GET_UFO_OBSERVATIONS_SUCCESS";
export const GET_UFO_OBSERVATIONS_FAILED = "GET_UFO_OBSERVATIONS_FAILED";
export const SET_INTERVAL_FILTER = "SET_INTERVAL_FILTER";

export const GET_SHIPWRECK_OBSERVATIONS_REQUESTED =
  "GET_SHIPWRECK_OBSERVATIONS_REQUESTED";
export const GET_SHIPWRECK_OBSERVATIONS_SUCCESS =
  "GET_SHIPWRECK_OBSERVATIONS_SUCCESS";
export const GET_SHIPWRECK_OBSERVATIONS_FAILED =
  "GET_SHIPWRECK_OBSERVATIONS_FAILED";



// WEBPACK FOOTER //
// ./src/reducers/actions.js